import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { LogOut, ShieldCheck } from "lucide-react";
import { useAuth } from "../state/auth";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_lighting-spec-gen/artifacts/sbtbxr0x_Helvar_basic_logo_2013.png";

export default function Header() {
  const { pathname } = useLocation();
  const nav = useNavigate();
  const { user, logout } = useAuth();

  const links = [{ to: "/", label: "Home" }];
  if (user) links.push({ to: "/wizard", label: "Builder" });
  if (user) links.push({ to: "/my-specifications", label: "My Specs" });
  if (user) links.push({ to: "/account", label: "Account" });
  if (user?.role === "admin") links.push({ to: "/admin", label: "Admin" });

  return (
    <header data-testid="site-header" className="sticky top-0 z-40 border-b border-[#e5e7eb] bg-white/95 backdrop-blur-sm">
      <div className="max-w-6xl mx-auto flex items-center justify-between px-4 sm:px-6 lg:px-10 h-16">
        <Link to="/" data-testid="brand-wordmark" className="flex items-center gap-3">
          <img src={LOGO_URL} alt="Helvar" className="h-6 sm:h-7 w-auto" style={{ objectFit: "contain" }} />
          <span className="hidden sm:inline text-[10px] uppercase tracking-[0.24em] text-[#4b5563] font-medium">
            Specification Builder
          </span>
        </Link>
        <nav className="flex items-center gap-1">
          {links.map((item) => {
            const active = pathname === item.to || (item.to !== "/" && pathname.startsWith(item.to));
            return (
              <Link
                key={item.to}
                to={item.to}
                data-testid={`nav-${item.label.toLowerCase()}`}
                className={`px-2 sm:px-4 py-2 text-xs sm:text-sm font-medium rounded-sm transition-colors ${
                  active
                    ? "text-[#1f2a44] bg-[#f4f5f7]"
                    : "text-[#4b5563] hover:text-[#1f2a44] hover:bg-[#f4f5f7]"
                }`}
              >
                {item.label}
              </Link>
            );
          })}
          {user ? (
            <div className="flex items-center gap-2 ml-1 pl-1 sm:ml-3 sm:pl-3 sm:border-l border-[#e5e7eb]">
              {user.role === "admin" && (
                <ShieldCheck className="h-3.5 w-3.5 text-[#c80f3f]" strokeWidth={1.75} />
              )}
              <span className="text-xs text-[#4b5563] hidden sm:inline max-w-[200px] truncate">
                {user.email}
              </span>
              <button
                type="button"
                onClick={async () => { await logout(); nav("/"); }}
                data-testid="logout-button"
                className="ml-1 h-8 w-8 flex items-center justify-center border border-[#e5e7eb] rounded-sm text-[#4b5563] hover:text-[#c80f3f] hover:border-[#c80f3f]"
                title="Sign out"
              >
                <LogOut className="h-3.5 w-3.5" strokeWidth={1.75} />
              </button>
            </div>
          ) : (
            <Link
              to="/login"
              data-testid="nav-sign-in"
              className="ml-3 px-4 py-2 text-sm font-medium rounded-sm bg-[#1f2a44] text-white hover:bg-[#161e31]"
            >
              Sign in
            </Link>
          )}
        </nav>
      </div>
      <div className="h-px w-full bg-gradient-to-r from-transparent via-[#c80f3f]/40 to-transparent" />
    </header>
  );
}
